import $ from 'jquery'

window.jQuery = $

$.ajaxSetup({
  cache: false,
  dataType: 'json'
})

export function request (url, setting) {
  return new Promise((resolve, reject) => {
    $.ajax(url, setting)
      .then(resolve)
      .fail(reject)
  })
}

export function get (url, params) {
  return request(url, {
    method: 'GET',
    data: params
  })
}

export function post (url, params) {
  return request(url, {
    method: 'POST',
    data: params
  })
}
